import { useState, useEffect } from 'react';

const useInfiniteScroll = (callback) => {
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  function handleScroll() {
    const windowHeight =
      'innerHeight' in window
        ? window.innerHeight
        : document.documentElement.offsetHeight;
    const body = document.body;
    const html = document.documentElement;
    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight,
    );
    const windowBottom = Math.round(windowHeight + window.pageYOffset);

    if (isFetching) return;

    if (windowBottom >= docHeight - 100 && !hasMore) {
      setIsFetching(true);
    }
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    if (!isFetching || !hasMore) return;
    callback();
  }, [isFetching, hasMore]);

  return [isFetching, setIsFetching, hasMore, setHasMore];
};

export default useInfiniteScroll;
